var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "main" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isLoading,
            expression: "isLoading",
          },
        ],
      },
      [_c("v-page-loading")],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isLoading,
            expression: "!isLoading",
          },
        ],
      },
      [
        _vm.error
          ? _c("div", { staticClass: "grid-container fluid" }, [
              _c(
                "div",
                {
                  staticClass: "grid-x grid-margin-x align-center align-middle",
                },
                [
                  _c("div", { staticClass: "cell small" }, [
                    _c("div", { staticClass: "callout alert text-center" }, [
                      _vm._v(_vm._s(_vm.$t("projectmap.error.loading"))),
                    ]),
                  ]),
                ]
              ),
            ])
          : _c(
              "div",
              { staticClass: "c-project-map" },
              [
                _c(
                  "div",
                  {
                    staticClass: "grid-container u-extra-small-margin--bottom",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "grid-x grid-margin-x align-middle" },
                      [
                        _c("div", { staticClass: "cell small-auto medium-2" }, [
                          _c(
                            "p",
                            {
                              staticClass:
                                "c-project-map__open-qm u-no-margin--bottom",
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("customers.projects_open")) +
                                  ": " +
                                  _vm._s(_vm.projectsCount)
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "cell small-auto medium-10" },
                          [
                            _c("div", { staticClass: "grid-container full" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "grid-x grid-padding-x align-middle",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "cell small-auto medium-3" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "form-group form-group--row u-no-margin--bottom",
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "u-no-margin--bottom text-right",
                                              attrs: {
                                                for: "form-field-qmmin",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("search.from")) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.filterQmMin,
                                                expression: "filterQmMin",
                                              },
                                            ],
                                            staticClass:
                                              "form-control form-control--small",
                                            attrs: {
                                              type: "number",
                                              inputmode: "decimal",
                                              id: "form-field-qmmin",
                                              name: "qmmin",
                                              placeholder: "qm",
                                            },
                                            domProps: {
                                              value: _vm.filterQmMin,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.filterQmMin =
                                                  $event.target.value
                                              },
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "u-no-margin--bottom text-right",
                                              attrs: {
                                                for: "form-field-qmmax",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("search.till")) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.filterQmMax,
                                                expression: "filterQmMax",
                                              },
                                            ],
                                            staticClass:
                                              "form-control form-control--small",
                                            attrs: {
                                              type: "number",
                                              inputmode: "decimal",
                                              id: "form-field-qmmax",
                                              name: "qmmax",
                                              placeholder: "qm",
                                            },
                                            domProps: {
                                              value: _vm.filterQmMax,
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.filterQmMax =
                                                  $event.target.value
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "cell small-auto medium-2" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "button",
                                          attrs: {
                                            title: _vm.$t(
                                              "projectmap.label.filterqm"
                                            ),
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.filterSquareMeters.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "projectmap.label.filterqm"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "cell small-auto medium-3" },
                                    [
                                      _c("v-project-map-asphalt-sort-filter", {
                                        attrs: {
                                          "filtered-projects": _vm.projects,
                                          resetLayerFilter:
                                            _vm.resetLayerFilter,
                                        },
                                        on: {
                                          selectedLayersChanged:
                                            _vm.populateMapWithFilterLayers,
                                          onResetDialogResults:
                                            _vm.onResetDialogResults,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "cell small-auto medium-2" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "button",
                                          attrs: {
                                            title: _vm.$t(
                                              "projectmap.label.resetmap"
                                            ),
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.resetMap.apply(
                                                null,
                                                arguments
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "projectmap.label.resetmap"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", {
                  ref: "projectmap",
                  staticStyle: { width: "100%", height: "100%" },
                  attrs: { id: "project-map-" + _vm._uid },
                }),
                _vm._v(" "),
                _c("v-form-message", {
                  attrs: {
                    type: "error",
                    id: "form-error",
                    message: _vm.objectError,
                  },
                  on: { onClickAction: _vm.onClickDialogAction },
                }),
              ],
              1
            ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }